/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { CheckBox, Tip } from '@insticator/insticator-ui'; // iui-materials
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/paymentinfo/enterinformation/preferselector/preferselector_styles';



/* ========== ~~~~~~~~~~ ACCOUNT PREFER SELECTOR ~~~~~~~~~~ ========== */
class PreferSelector extends Component {
    handleClick = () => {
        this.props.updatePreferredPaymentType(this.props.selectedPaymentType);
        if (this.props.selectedPaymentType !== this.props.preferredPaymentType) this.props.sendMessage('After checking this box and saving, all payments from now on will be made through this new payment method.')
    };
    render() {
        return(
            <div className={`preferred-payment preferselector editable-${(this.props.editable && !(this.props.selectedPaymentType === this.props.preferredPaymentType)) && this.props.preferredPaymentType !== null} ${this.props.classes.preferselector}`}>
                <CheckBox handleClick={this.handleClick} color={`primary`} on={this.props.fields.preferredPayment.value || this.props.preferredPaymentType === null} />
                <span className={`preferred-payment-copy`} >Preferred Payment Method</span>
                <Tip space={`left`} content={<p>If you check this box, this will override your current preferred payment method, and you will stop receiving payments through that method. All payments from now on will be made through this new payment method.</p>} />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PreferSelector);
